export default __webpack_public_path__ + "static/FördervereinLuisen_Beitrittsformular-a2cc1fc178141745cd8dd3c66def40e8.pdf";